import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import Button from 'components/Button';
import Warning from 'components/Warning';
import {default as Modal, withModal} from 'components/Modal';

import {storeDataInModal} from 'ducks/modals';
import {MODALS, fetchNextPossibleChargeDate} from 'ducks/tenancy';

import {InitiateGoCardlessPaymentForm} from './components';

import './styles.css';

class InitiateGoCardlessPaymentModal extends React.Component<any> {
  componentDidMount() {
    const {data: {tenancyId}} = this.props;

    this.props.fetchNextPossibleChargeDate({tenancyId}, [
      ({nextPossibleChargeDate}) =>
        storeDataInModal({
          modalName: MODALS.INITIATE_GOCARDLESS_PAYMENT,
          data: {
            nextPossibleChargeDate
          }
        })
    ]);
  }

  submitForm = () => {
    this.props.submit('initiateGoCardlessPaymentForm');
  };

  getExtraActions = () => this.props.closeModalExtraActions;

  render() {
    const {
      closeModal,
      data: {
        isDueDateInFuture,
        invoiceId,
        nextPossibleChargeDate,
        amount,
        description,
        invoice
      },
      form: {submitting}
    } = this.props;

    return (
      <Modal
        className="InitiateGoCardlessPaymentModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={closeModal}>
        <Modal.Header heading="Create GoCardless Payment" />
        <Modal.Body>
          {isDueDateInFuture && (
            <Warning>The due date for this invoice is in future</Warning>
          )}
          <InitiateGoCardlessPaymentForm
            invoice={invoice}
            invoiceId={invoiceId}
            amount={amount}
            description={description}
            nextPossibleChargeDate={nextPossibleChargeDate}
            getExtraActions={this.getExtraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="Buttons">
            <Button white className="cancel" onClick={closeModal}>
              Cancel
            </Button>
            <Button
              className="confirm"
              disabled={submitting}
              blue={!submitting}
              isLoading={submitting}
              onClick={this.submitForm}>
              Create payment
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('initiateGoCardlessPaymentForm')(state)
    }
  };
};
const mapDispatchToProps = {submit, fetchNextPossibleChargeDate};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.INITIATE_GOCARDLESS_PAYMENT)(InitiateGoCardlessPaymentModal)
);
